// useProject — haalt één project op aan de hand van id.

import { useCallback, useEffect, useState } from 'react';
import { api, endpoints } from '../api/client.js';

export function useProject(projectId) {
    const [project, setProject] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const load = useCallback(async () => {
        if (!projectId) { setLoading(false); return; }
        setLoading(true);
        setError(null);
        try {
            const data = await api.get(endpoints.project(projectId));
            setProject(data?.project || data);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    }, [projectId]);

    useEffect(() => { load(); }, [load]);

    const update = useCallback(async (patch) => {
        if (!projectId) { return null; }
        const res = await api.patch(endpoints.project(projectId), patch);
        setProject(res?.project || res || null);
        return res;
    }, [projectId]);

    return { project, loading, error, reload: load, update, setProject };
}
